import { Injectable } from "@angular/core";
import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Observable, catchError, tap, throwError } from "rxjs";
import { ApiCapture } from "../utils/api-capture";

@Injectable()
export class ApiSchemaCaptureInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!ApiCapture.isEnabled() || ApiCapture.shouldIgnoreRequest(req)) {
			return next.handle(req);
		}

		return next.handle(req).pipe(
			tap((event) => {
				if (event instanceof HttpResponse) {
					ApiCapture.recordHttp(req, event);
				}
			}),
			catchError((error: HttpErrorResponse) => {
				ApiCapture.recordHttp(req, undefined, error);
				return throwError(() => error);
			})
		);
	}
}
